module.exports = __webpack_public_path__ + "img/float-btn-lottery.0f1edf77.svg";